import React from "react";
import { Link } from "react-router-dom";
import { Translation } from "react-i18next";
import LangTools from "./LangTools";

const Header = props => {
  return (
    <Translation>
      {t => (
        <div id="header">
          <LangTools />
        </div>
      )}
    </Translation>
  );
};

export default Header;
